import { ITemplateFormData } from '../models';

export function isPartnersFormValid(data: Partial<ITemplateFormData>) {
	return data?.partners?.length;
}
